import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FaIconComponent, type IconDefinition } from '@fortawesome/angular-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { InputCheckboxComponent } from '../input-checkbox/input-checkbox.component';

@Component({
  selector: 'rcp-option-list-item',
  template: `
    <div
      class="flex flex-gap clickable option-item"
      (click)="$event.stopImmediatePropagation(); toggle.emit()"
      [class.active]="selected()"
      [class.align-center]="centerContent()"
    >
      @if (type() === 'multi') {
        <rcp-input-checkbox [value]="selected()" [disabled]="disabled()" (select)="toggle.emit()" />
      } @else if (icon()) {
        <fa-icon [icon]="icon()" />
      }

      <!-- use all available space  -->
      <div class="flex inline-flex option-content flex-grow" [class.align-center]="centerContent()">
        <ng-content></ng-content>
      </div>

      @if (type() === 'single' && selected()) {
        <fa-icon [icon]="faCheck" />
      }
    </div>
  `,
  styles: `
    :host {
      display: flex;
      gap: var(--item-spacing-between-md);
      min-height: var(--item-height-md);
    }

    /*
    set a minimum width of 0px instead of auto to prevent
    the selected icon being pushed out of the container
    */
    .option-content {
      min-width: 0px;
    }

    .option-item {
      padding: var(--item-padding-md);
      border-radius: var(--br);

      &:hover {
        background-color: var(--col-active-bg);
        color: var(--col-active-text);
        --col-text-secondary: var(--col-active-text-secondary);
      }

      &:focus {
        border: 1px solid var(--col-active-lines);
        background-color: var(--col-active-bg);
        color: var(--col-active-text);
        --col-text-secondary: var(--col-active-text-secondary);
      }

      &.active {
        background-color: var(--col-active-bg);
        color: var(--col-active-text);
        --col-text-secondary: var(--col-active-text-secondary);
      }
    }
  `,
  imports: [FaIconComponent, InputCheckboxComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class OptionListItemComponent {
  selected = input<boolean>(false);
  disabled = input<boolean>(false);
  centerContent = input<boolean>(true);

  type = input<'single' | 'multi'>('multi');
  icon = input<IconDefinition>();

  toggle = output<void>();

  protected readonly faCheck = faCheck;
}
